// @ts-nocheck

import { EmptyState, NoDataIcon } from '@lmc/ui-kit'
import { css, StyleSheet } from 'aphrodite/no-important'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Component } from 'react'
import { connect } from 'react-redux'
import Actions from '../../../actions'
import ListHeaderSearch from '../../../LEGACY/ListHeaderSearch'
import Operations from '../../../operations'
import { ResidentProfileImportantPeople } from '../../../screens/Residents/screens/ResidentProfileScreen/_legacyReidentProfileScreen/components'

export class FamilyInviteWizard extends Component {
  state = { search: '' }

  handleSearchChange = (e) => {
    const newValue = e.target.value
    this.setState({ search: newValue })
  }

  handleSearchClear = () => {
    this.setState({ search: '' })
  }

  filterResidentsBySearch = (residents) => {
    const pattern = new RegExp(
      this.state.search.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'),
      'i'
    )
    return _.filter(residents, (res) =>
      `${res.name.first} ${res.name.last}`.match(pattern)
    )
  }

  renderResidents = (filteredResidents) => {
    const { carers, familySetupComplete, resendInvite, openFamilyInviteModal } =
      this.props

    return filteredResidents.map((resident) => (
      <div key={resident.id} className={css(classes.residentSectionContainer)}>
        <ResidentProfileImportantPeople
          profile={resident}
          family
          familySetupComplete={familySetupComplete}
          carers={carers}
          marginTop={10}
          showGP={false}
          residentName={`${resident.name.first} ${resident.name.last}`}
          resendInvite={resendInvite}
          openFamilyInviteModal={openFamilyInviteModal}
        />
      </div>
    ))
  }

  renderEmpty = (preferredTerm) => (
    <EmptyState
      title="Shoot... No data to show you"
      icon={<NoDataIcon />}
      description={`No ${preferredTerm}s found`}
    />
  )

  render() {
    const { residents, preferredPeopleNominative } = this.props

    if (!preferredPeopleNominative) return null

    // Residents -> resident
    const preferredTerm = preferredPeopleNominative.slice(0, -1).toLowerCase()
    const filteredResidents = this.filterResidentsBySearch(residents)

    return (
      <div className={css(classes.container)}>
        <div className={css(classes.searchBoxParentContainer)}>
          <ListHeaderSearch
            handleChange={this.handleSearchChange}
            handleClear={this.handleSearchClear}
            inputStyle={classes.searchInput}
            placeholder={`Search ${preferredTerm}'s name`}
            style={classes.searchWrapper}
            value={this.state.search}
          />
        </div>
        <div className={css(classes.residentsContainer)}>
          {filteredResidents.length > 0
            ? this.renderResidents(filteredResidents)
            : this.renderEmpty(preferredTerm)}
        </div>
      </div>
    )
  }
}

FamilyInviteWizard.propTypes = {
  carers: PropTypes.array,
  familySetupComplete: PropTypes.bool,
  openFamilyInviteModal: PropTypes.func,
  preferredPeopleNominative: PropTypes.string,
  resendInvite: PropTypes.func,
  residents: PropTypes.array
}

const classes = StyleSheet.create({
  container: {
    width: '100%'
  },
  residentSectionContainer: {
    marginTop: 50,
    marginBottom: 50,
    display: 'block'
  },
  searchBoxParentContainer: {
    width: '100%',
    marginBottom: 10
  },
  searchInput: {
    fontSize: 16
  },
  searchWrapper: {
    flex: 1,
    backgroundColor: 'blue'
  },
  residentsContainer: {
    width: '100%'
  },
  blankState: {
    marginBottom: 20
  }
})

const mapStateToProps = (state, props) => {
  return {
    carers: state.data.carers,
    preferredPeopleNominative: state.global.home.preferredPeopleNominative,
    familySetupComplete: state.global.home.familySetupComplete,
    residents: _.filter(state.data.residents, { status: 'active' })
  }
}

const mapDispatchToProps = (dispatch) => ({
  openFamilyInviteModal: (contact, index, profile) => {
    const id = 'inviteFamily'
    dispatch(
      Actions.openModal({
        modalId: id,
        data: {
          residentId: profile.id,
          residentName: {
            first: profile.name.first,
            last: profile.name.last
          },
          importantContact: contact,
          index
        }
      })
    )
  },
  resendInvite: (userId, cb) => dispatch(Operations.resendInvite(userId, cb))
})

export default connect(mapStateToProps, mapDispatchToProps)(FamilyInviteWizard)
